<template>
  <div class="com-box" v-if="imgList.length">
    <div class="bgd"></div>
    <div class="img-box" v-for="item in imgList" :key="item.moduleDetailValue">
      <van-image v-if="item.detailDataType == 1" 
        width="100%" 
        height="auto" 
        :src="item.moduleDetailValue" 
        fit="cover" />
      <video v-else-if="item.detailDataType == 2"
        :src="item.moduleDetailValue" controls="controls" 
        x5-video-player-type="h5-page" 
        x5-video-player-fullscreen="false" 
        x5-playsinline="" 
        playsinline=""
        webkit-playsinline="true"></video>
    </div>
  </div>
  <div class="com-box-view" v-else>
    <div class="img-box-view">
      <van-image class="img-demo-view" :src="img" fit="cover" />
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
.com-box
  position relative
  // margin-top: 50px;
  .bgd
    position absolute
    top -25px
    width 100%
    height 50px
    background #fff
    opacity 0.38
    border-radius 10px
  .img-box
    position relative
    overflow hidden
    font-size 0
    display block;
    video
      width 100%
      height 194px
      background #000
.com-box-view
  margin 15px
  padding 5px 0
  background linear-gradient(#FFE8DF, #FFE8DF)
  border-radius: 12px
  .img-box-view
    margin 12px
    background-color: #FFF0EA
    border-radius: 12px
    overflow hidden
    font-size 0
</style>